import api from './api';

// Stats
export const getStats = () => api.get('/admin/stats');
// Лента «Последние действия»: регистрации, зачисления, снятия с курса, отключения
// before — дата последнего показанного события: следующая порция начинается с неё
export const getAdminActivity = (limit = 20, before = null) =>
  api.get('/admin/activity', { params: { limit, ...(before ? { before } : {}) } });

// Профиль администратора
export const getNotifyPrefs = () => api.get('/admin/profile/notifications');
export const setNotifyPrefs = (prefs) => api.put('/admin/profile/notifications', prefs);
export const getAdminSessions = () => api.get('/admin/profile/sessions');
export const revokeAdminSession = (id) => api.delete(`/admin/profile/sessions/${id}`);
export const getCourseStats = (courseId) => api.get(`/admin/stats/courses/${courseId}`);
// Всё для экрана «Статистика» по курсу: показатели, модули с уроками, ученики
export const getCourseOverview = (courseId) => api.get(`/admin/stats/courses/${courseId}/overview`);

// Course Page
export const getCoursePage = (courseId) => api.get(`/admin/course-page/${courseId}`);
export const updateCoursePage = (courseId, data) => api.put(`/admin/course-page/${courseId}`, data);

// Courses
export const getCourses = () => api.get('/admin/courses');
export const createCourse = (data) => api.post('/admin/courses', data);
export const duplicateCourse = (id, data) => api.post(`/admin/courses/${id}/duplicate`, data);
// Публикация всего курса + режим восстановления удалённых
export const publishAllInCourse = (id) => api.post(`/admin/courses/${id}/publish-all`);
export const getDeletedInCourse = (id) => api.get(`/admin/courses/${id}/deleted`);
export const restoreSection = (id) => api.post(`/admin/sections/${id}/restore`);
export const restoreLesson = (id) => api.post(`/admin/lessons/${id}/restore`);
export const duplicateSection = (id) => api.post(`/admin/sections/${id}/duplicate`);
// Отметить модуль «текущим» (у ученика раскрывается по умолчанию) / снять отметку
export const makeCurrentSection = (id, current = true) => api.post(`/admin/sections/${id}/make-current`, { current });
export const duplicateLesson = (id, sectionId) => api.post(`/admin/lessons/${id}/duplicate`, sectionId ? { sectionId } : {});

// Перетаскивание (drag-and-drop): принимают массив id в нужном порядке
export const reorderCourses = (ids) => api.put('/admin/courses/reorder', { ids });
export const reorderSections = (ids) => api.put('/admin/sections/reorder', { ids });
export const reorderLessons = (ids) => api.put('/admin/lessons/reorder', { ids });
export const reorderHomeworks = (ids) => api.put('/admin/homeworks/reorder', { ids });
export const updateCourse = (id, data) => api.put(`/admin/courses/${id}`, data);
export const deleteCourse = (id) => api.delete(`/admin/courses/${id}`);

// Sections
export const getSections = (courseId) => api.get(`/admin/sections?courseId=${courseId || ''}`);
export const createSection = (data) => api.post('/admin/sections', data);
export const updateSection = (id, data) => api.put(`/admin/sections/${id}`, data);
export const deleteSection = (id, force) => api.delete(`/admin/sections/${id}${force ? '?force=1' : ''}`);

// Lessons
export const getLessons = (sectionId) => api.get(`/admin/lessons?sectionId=${sectionId || ''}`);
export const createLesson = (data) => api.post('/admin/lessons', data);
export const updateLesson = (id, data) => api.put(`/admin/lessons/${id}`, data);
export const deleteLesson = (id, force) => api.delete(`/admin/lessons/${id}${force ? '?force=1' : ''}`);
// onProgress(pct) — чтобы у админа было видно, сколько ещё ждать: большие
// материалы льются долго, и без индикатора кнопка выглядит зависшей.
export const uploadMaterials = (id, formData, onProgress) =>
  api.post(`/admin/lessons/${id}/materials`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,                      // большие файлы не должны обрываться по таймауту
    onUploadProgress: (e) => {
      if (!onProgress || !e.total) return;
      onProgress(Math.min(100, Math.round((e.loaded / e.total) * 100)));
    },
  });
export const deleteMaterial = (lessonId, materialIndex) => 
  api.delete(`/admin/lessons/${lessonId}/materials/${materialIndex}`);

// Homeworks
export const getHomeworks = () => api.get('/admin/homeworks');
export const createHomework = (data) => api.post('/admin/homeworks', data);
export const updateHomework = (id, data) => api.put(`/admin/homeworks/${id}`, data);
export const deleteHomework = (id) => api.delete(`/admin/homeworks/${id}`);

// Варианты (пробники). Номера правятся обычными createHomework/updateHomework/deleteHomework.
export const getVariants = (courseId) => api.get(`/admin/variants?courseId=${courseId || ''}`);
export const getVariant = (id) => api.get(`/admin/variants/${id}`);
export const createVariant = (data) => api.post('/admin/variants', data);
export const updateVariant = (id, data) => api.put(`/admin/variants/${id}`, data);
export const deleteVariant = (id) => api.delete(`/admin/variants/${id}`);
export const duplicateVariant = (id) => api.post(`/admin/variants/${id}/duplicate`);
export const uploadSolution = (id, formData) => 
  api.post(`/admin/homeworks/${id}/solution`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

// Homework answers
// Доступ пробникам: какие занятия курса им открыты
export const getTrialAccess = (courseId) => api.get(`/admin/trial-access?courseId=${courseId}`);
export const setTrialAccess = (courseId, lessonIds) => api.put('/admin/trial-access', { courseId, lessonIds });

export const getHomeworkAnswers = () => api.get('/admin/homework-answers');
// Архив: работы, которые уже проверены и ничего не ждут
export const getReviewArchive = (limit = 30, offset = 0) =>
  api.get(`/admin/homework-answers/archive?limit=${limit}&offset=${offset}`);
// body: { status?, score?, comment? } — можно и просто статусом, и с баллами
export const reviewAnswer = (id, body) =>
  api.put(`/admin/homework-answers/${id}/review`, typeof body === 'string' ? { status: body } : body);

// Students
export const getStudents = (includeInactive = false) =>
  api.get(`/admin/students${includeInactive ? '?includeInactive=1' : ''}`);
export const inviteStudent = (data) => api.post('/admin/students/invite', data);
export const removeStudent = (id, courseId) => api.delete(`/admin/students/${id}`, { data: courseId ? { courseId } : {} });
// Деактивировать/активировать аккаунт (мягкое удаление с платформы)
export const setStudentActive = (id, isActive) =>
  api.put(`/admin/students/${id}/active`, { isActive });
// Удалить ученика навсегда: аккаунт, курсы, прогресс, ответы — без архива
export const deleteStudentForever = (id) => api.delete(`/admin/students/${id}/permanent`);
// Доступы: до какого дня у ученика доступ (одна дата на все курсы) и продление
export const getAccess = () => api.get('/admin/access');
export const extendAccess = (userIds, { months, weeks, date } = {}) =>
  api.post('/admin/access/extend', { userIds, months, weeks, date });
export const getStudentProgress = (id) => api.get(`/admin/students/${id}/progress`);
// Полная карточка ученика для модалки: курсы, модули, ДЗ по номерам, варианты, лента
export const getStudentOverview = (id) => api.get(`/admin/students/${id}/overview`);
// Сгенерировать (или получить существующий) код ученика для родителя
export const ensureStudentCode = (id) => api.post(`/admin/students/${id}/progress-code`);

// Invitations
export const getInvitations = () => api.get('/admin/students/invitations');
export const resendInvitation = (invitationId) => 
  api.post('/admin/students/resend-invitation', { invitationId });
export const cancelInvitation = (invitationId) => 
  api.delete(`/admin/students/invitations/${invitationId}`);
  
// Assign course to student
export const assignCourseToStudent = (userId, courseId) =>
  api.post('/admin/students/assign-course', { userId, courseId });

// Homework progress
export const getHWProgressByStudent = () => api.get('/admin/homework-progress/students');
export const getStudentHWDetail = (studentId) => api.get(`/admin/homework-progress/students/${studentId}`);
export const getHWProgressByTask = () => api.get('/admin/homework-progress/homeworks');
// «Ещё попытку»: прошлый результат остаётся, засчитывается лучший
export const grantExtraAttempt = (studentId, lessonId) =>
  api.post(`/admin/students/${studentId}/lessons/${lessonId}/extra-attempt`);

// Personal Zoom links
export const importZoomLinks = (links) => api.post('/admin/students/import-zoom-links', { links });
export const updateStudent = (id, patch) => api.put(`/admin/students/${id}`, patch);
export const setStudentZoomLink = (id, zoomLink) => api.put(`/admin/students/${id}/zoom-link`, { zoomLink });

/* Сотрудники: состав админки и роли. Доступно только главному администратору —
   остальным сервер ответит отказом. */
export const getStaff = () => api.get('/admin/staff');
export const createStaff = (data) => api.post('/admin/staff', data);
export const updateStaff = (id, data) => api.put(`/admin/staff/${id}`, data);
export const setStaffActive = (id, isActive) => api.put(`/admin/staff/${id}/active`, { isActive });
export const deleteStaff = (id) => api.delete(`/admin/staff/${id}`);
